import { useEffect, useRef } from "react";

export const SandParticles = ({ density = 45, className = "" }) => {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const DPR = Math.min(window.devicePixelRatio || 1, 2);
    let raf;
    let w = 0;
    let h = 0;
    let parts = [];

    const spawn = () =>
      Array.from({ length: density }, () => ({
        x: Math.random() * w,
        y: Math.random() * h,
        r: 0.6 + Math.random() * 1.8,
        s: 0.1 + Math.random() * 0.35,
        drift: Math.random() * Math.PI * 2,
        a: 0.12 + Math.random() * 0.45,
      }));

    const resize = () => {
      w = canvas.offsetWidth;
      h = canvas.offsetHeight;
      canvas.width = w * DPR;
      canvas.height = h * DPR;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    };

    const paint = () => {
      ctx.clearRect(0, 0, w, h);
      for (const p of parts) {
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(232, 196, 92, ${p.a})`;
        ctx.shadowColor = "rgba(212, 175, 55, 0.8)";
        ctx.shadowBlur = 6;
        ctx.fill();
      }
    };

    const tick = () => {
      for (const p of parts) {
        p.y -= p.s;
        p.drift += 0.008;
        p.x += Math.sin(p.drift) * 0.25;
        if (p.y < -6) {
          p.y = h + 6;
          p.x = Math.random() * w;
        }
      }
      paint();
      raf = requestAnimationFrame(tick);
    };

    resize();
    parts = spawn();
    if (reduced) paint();
    else tick();

    const onResize = () => {
      resize();
      parts = spawn();
      if (reduced) paint();
    };
    window.addEventListener("resize", onResize);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", onResize);
    };
  }, [density]);

  return (
    <canvas
      ref={ref}
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 h-full w-full ${className}`}
    />
  );
};
